import { render, staticRenderFns } from "./RechargePrepaidMb_old.vue?vue&type=template&id=5dae4434&scoped=true&"
import script from "./RechargePrepaidMb_old.vue?vue&type=script&lang=js&"
export * from "./RechargePrepaidMb_old.vue?vue&type=script&lang=js&"
import style0 from "./RechargePrepaidMb_old.vue?vue&type=style&index=0&id=5dae4434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae4434",
  null
  
)

export default component.exports